import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { appStorage } from '@sternum/web/services/appStorage';

export interface LogsState {
  expandedRows: Record<string, boolean>;
  isChartVisible: boolean;
  isPolling: boolean;
  isFiltersPanelOpen: boolean;
}

const initialState: LogsState = {
  expandedRows: {},
  isChartVisible: appStorage.getIsLogsChartVisible() ?? true,
  isPolling: appStorage.getIsLogsTablePolling() ?? true,
  isFiltersPanelOpen: appStorage.getIsLogsFiltersPanelOpen() ?? true,
};

export const logsSlice = createSlice({
  name: 'logs',
  initialState,
  reducers: {
    toggleRowAction: function (state, action: PayloadAction<string>) {
      const rowId = action.payload;
      const isRowExpanded = state.expandedRows[rowId];

      if (isRowExpanded) {
        delete state.expandedRows[rowId];
      } else {
        state.expandedRows[action.payload] = true;
      }

      state.isPolling = state.isPolling && !Object.values(state.expandedRows).some((expanded) => expanded);
      appStorage.setIsLogsTablePolling(state.isPolling);
    },
    collapseAllAction(state) {
      state.expandedRows = {};
    },
    toggleIsFiltersPanelOpen(state) {
      state.isFiltersPanelOpen = !state.isFiltersPanelOpen;
    },
    toggleIsChartVisible(state) {
      state.isChartVisible = !state.isChartVisible;
    },
    togglePollLogsPage(state) {
      state.isPolling = !state.isPolling;
      appStorage.setIsLogsTablePolling(state.isPolling);
    },
    stopPollingLogsPage(state) {
      state.isPolling = false;
      appStorage.setIsLogsTablePolling(state.isPolling);
    },
    startPollingLogsPage(state) {
      state.isPolling = true;
      appStorage.setIsLogsTablePolling(state.isPolling);
    },
  },
});

export const {
  toggleRowAction,
  toggleIsChartVisible,
  collapseAllAction,
  toggleIsFiltersPanelOpen,
  togglePollLogsPage,
  stopPollingLogsPage,
  startPollingLogsPage,
} = logsSlice.actions;
